import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { UiComponents } from "@simulanisindia/ui";
import { AddProjectIcon, AddProjectLightIcon } from "../../assets/icons/icons";
import BtnLoad from "../common/BtnLoad";
import apiclient from "../../apiclient";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { removeExtraSpace } from "../../utils/general";

const { useUnoSelector } = UnoStoreHooks;
const { SimInputBar } = UiComponents;

const AddProject = ({ handleClose, show, handleGetProjectList }) => {
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [newProject, setNewProject] = useState({ name: "" });
  const [error, setError] = useState();

    const validateForm = () => {
    let error = false;
    let errorObj = {};

    Object.entries(newProject).forEach(([key, val]) => {
      if (!removeExtraSpace(val)) {
        error = true;
        errorObj[key] = `${key} is required *`;
      }
    });

    setError(errorObj);
    return error;
  };

  const createNewProject = async () => {
    if(loading) return;
    try {
      if (validateForm()) return;
      setLoading(true);
      let _data = {
        name: removeExtraSpace(newProject.name),
        // template: configData.config.templateData,
      };
      await apiclient.post(`${configData.config.API_URL}/api/project/create`, _data, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });
      handleGetProjectList();
      closeModal();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const closeModal = () => {
    setLoading(false);
    handleClose();
    setError({});
  };

  return (
    <>
      <Modal show={show} centered onHide={closeModal} className="createModal">
        <div className="customModalHead">
          <div className="filterbtn">
            <div className="btninadjust">
              <AddProjectLightIcon />
            </div>
          </div>
          <h6>Add Project</h6>
        </div>
        <Modal.Body>
          <div className="projectCreation">
            <div className="inputItem">
              <p>Project Name</p>
              <SimInputBar
                onChange={(e) => setNewProject((prev) => ({ ...prev, name: e.target.value }))}
                placeholder="Name"
              />
              {error?.name && <p className="text-danger small px-1">{error?.name}</p>}
            </div>
          </div>
        </Modal.Body>
        <div className="modalFooterB">
          <button className="cancel" onClick={closeModal}>
            Cancel
          </button>
          <button className="save" onClick={createNewProject}>
              { loading ? <BtnLoad /> : "Add"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddProject;
